module.exports = __webpack_public_path__ + "img/bb43.ad42377b.png";